import * as React from 'react';
import { SVGProps } from 'react';

const SvgMedical = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 6V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-4zm-2-2v2h-4V4h4zm6 16H4V8h16v12zm-9-10v3H8v2h3v3h2v-3h3v-2h-3v-3h-2z" />
  </svg>
);

export default SvgMedical;
